import { saveAs } from 'file-saver';

// Function to send business plan to Telegram through the secure backend API
async function sendBusinessPlanToTelegram(name, email, businessPlan, workflowData) {
  try {
    console.log("Sending business plan to backend for Telegram notification:", { name, email });
    
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/send-telegram-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_SERVER_API_KEY,
      },
      body: JSON.stringify({
        name,
        email,
        businessPlan,
        workflowData,
        notificationType: 'business_plan_generated'
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log("Telegram notification result:", result);
    return result.success;
  } catch (error) {
    console.error('Error sending notification through backend:', error);
    // Don't expose error details to the frontend
    throw new Error('Failed to send notification');
  }
}

// Function to send workflow export to Telegram through the secure backend API
async function sendWorkflowExportToTelegram(name, email, workflowData) {
  try {
    console.log("Sending workflow export to backend for Telegram notification:", { name, email });
    
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/send-telegram-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_SERVER_API_KEY,
      },
      body: JSON.stringify({
        name,
        email,
        workflowData,
        notificationType: 'workflow_export'
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log("Telegram workflow export result:", result);
    return result.success;
  } catch (error) {
    console.error('Error sending workflow export through backend:', error);
    // Don't expose error details to the frontend
    throw new Error('Failed to send workflow export notification');
  }
}

export { 
  sendBusinessPlanToTelegram,
  sendWorkflowExportToTelegram
};